import React from 'react'
import { DocumentHeaderProps } from '../../../types'
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Chip, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const DocumentHeader: React.FC<DocumentHeaderProps> = ({
  heading,
  subtitle,
  status,
  statusColor = 'primary',
  onBack,
  onSave,
  onCancel,
  saveButtonText = 'Save',
  cancelButtonText = 'Cancle',
  saveDisabled = false,
  cancelDisabled = false,
  loading = false,
  showBackButton = false,
  showSaveButton = false,
  showCancelButton = false,
  saveIcon = <SaveIcon />,
  cancelIcon = <CancelIcon />,

  additionalButtons= [],
  customActions
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1)
    }
  }
  return (
    <Box sx={{ width: '100%', mb: 3 }}>
      <Stack direction='row' alignItems='center' justifyContent='space-between' spacing={2}>
        <Stack direction={'row'} alignItems={'center'} spacing={2} flex={1}>
          {showBackButton && (
            <Tooltip title="Go Back" placement='top' arrow>
              <IconButton onClick={handleBack} disabled={loading} size='small'>
                <ArrowBackIcon />
              </IconButton>
            </Tooltip>
          )}
          <Box sx={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center" }}>
            <Stack direction={'row'} alignItems={'center'} spacing={2}>
              <Typography variant='h5' component={'h1'} fontWeight={600}>
                {heading}
              </Typography>
              {subtitle && (
                <Typography variant='subtitle1' color='text.secondary' sx={{ fontSize: '0.8rem' }}>
                  {subtitle}
                </Typography>
              )}
              {status && (
                <Chip
                  label={status}
                  color={statusColor as any}
                  size='small'
                  variant='outlined'
                />
              )}
            </Stack>

            {/* Right side: Action buttons */}
            <Stack direction="row" spacing={1} alignItems="center" pr={2}>
              {additionalButtons.map((button, index) => (
                <Tooltip key={index} title={button.tooltip || ''} placement='top' arrow>
                  <Button
                    size='small'
                    variant={button.variant || 'outlined'}
                    onClick={button.onClick}
                    disabled={button.disabled || loading}
                    startIcon={button.icon}
                    color={button.color || 'primary'}
                  >
                    {button.label}
                  </Button>
                </Tooltip>
              ))}
              
              {showCancelButton && onCancel && (
                <Button
                  size='small'
                  variant="outlined"
                  onClick={onCancel}
                  disabled={cancelDisabled || loading}
                  startIcon={cancelIcon}
                  color="inherit"
                >
                  {cancelButtonText}
                </Button>
              )}

              {showSaveButton && onSave && (
                <Button
                  size='small'
                  variant="contained"
                  onClick={onSave}
                  disabled={saveDisabled || loading}
                  startIcon={saveIcon}
                >
                  {saveButtonText}
                </Button>
              )}
            </Stack>
          </Box>
        </Stack>
      </Stack>
    </Box>
  )
}

export default DocumentHeader